import * as React from 'react'
import classNames from 'classnames'

import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import Ruler from '../../00-Primitives/Ruler'
import style from './style.scss'

type Props = {
  className?: string
  bodyText: string
  headlineText: string
}

function MainInfo({ bodyText, className, headlineText }: Props) {
  return (
    <div className={classNames(style.wrapper, className)}>
      <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      <Ruler className={style.mainInfoRuler} />
      <Paragraph className={style.bodyText}>{bodyText}</Paragraph>
    </div>
  )
}

export default MainInfo
